export const APPLICATION = 'MathNation';
